import UserGroup from '@/models/UserGroup';

export default {
  state: () => ({
    userGroups: [],
  }),

  mutations: {
    setUserGroups(state, payload = null) {
      state.userGroups = payload;
    },
  },

  getters: {
    userGroups({ userGroups }) {
      return UserGroup.collection(userGroups);
    },
  },

  actions: {
    async loadUserGroups({ commit }) {
      let userGroups = UserGroup.collection();
      let { data } = await userGroups.$fetch();
      commit('setUserGroups', data);
    },
  },
};
